/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import Col from 'react-bootstrap/Col';

export const ColContainer = styled(Col)`
  padding: 2% 5%;
  @media (max-width: 360px) {
    padding: 2%;
  }
`;
